import { render, staticRenderFns } from "./DeletedStaff.vue?vue&type=template&id=0e35d15d&"
import script from "./DeletedStaff.vue?vue&type=script&lang=js&"
export * from "./DeletedStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports